import React from 'react';
import { Box, styled } from '@mui/material';
import { Sidebar } from '../../sharedComponents/Sidebar';

const PageContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  height: '100vh',
  overflow: 'hidden',
  backgroundColor: theme.palette.background.default,
}));

const MainContent = styled(Box)({
  flex: 1,
  overflow: 'auto',
});

export const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <PageContainer>
      <Sidebar />
      <MainContent>
        {children}
      </MainContent>
    </PageContainer>
  );
};


